import apiClient from './client';

export interface Note {
  id: string;
  title: string;
  content: string;
  user: string;
  isCompleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateNoteRequest {
  title: string;
  content: string;
}

export interface UpdateNoteRequest {
  title?: string;
  content?: string;
  isCompleted?: boolean;
}

export const notesApi = {
  getAll: async (): Promise<Note[]> => {
    const response = await apiClient.get('/notes');
    return response.data.map((item: any) => ({ ...item, id: item._id }));
  },

  getById: async (id: string): Promise<Note> => {
    const response = await apiClient.get(`/notes/${id}`);
    return { ...response.data, id: response.data._id };
  },

  create: async (data: CreateNoteRequest): Promise<Note> => {
    const response = await apiClient.post('/notes', data);
    return { ...response.data, id: response.data._id };
  },

  update: async (id: string, data: UpdateNoteRequest): Promise<Note> => {
    const response = await apiClient.put(`/notes/${id}`, data);
    return { ...response.data, id: response.data._id };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/notes/${id}`);
  },
};
